import { fmtDateTime } from "@/lib/api";

const Result = ({ check, latest }) => (
  <div className={`rounded-xl border p-5 ${latest ? "border-[#4A3B43] bg-[#1E181B]" : "border-[#2E252A] bg-[#161214]"}`} data-testid={latest ? "inventory-latest" : "inventory-history-item"}>
    <div className="flex flex-wrap items-baseline justify-between gap-2">
      <p className="font-mono text-xs text-[#D4AF37]" data-testid={latest ? "inventory-latest-date" : undefined}>{fmtDateTime(check.checked_at)} · {check.user_name}</p>
      <p className={`text-sm ${check.missing.length ? "text-[#E5A93C]" : "text-emerald-400"}`} data-testid={latest ? "inventory-latest-summary" : undefined}>
        {check.found} / {check.expected} found{check.missing.length ? ` · ${check.missing.length} missing` : " · all present"}
      </p>
    </div>
    {!!check.missing.length && (
      <div className="mt-3" data-testid={latest ? "inventory-missing-list" : undefined}>
        <p className="text-[11px] uppercase tracking-widest text-[#6E665D] mb-1.5">Missing</p>
        {check.missing.map((m) => (
          <p key={m.barcode} className="text-sm text-[#F5F0EB]"><span className="font-mono text-xs text-[#E5A93C] mr-3">{m.barcode}</span>{m.label}{m.box_number ? ` · box ${m.box_number}` : ""}</p>
        ))}
      </div>
    )}
    {!!check.unexpected.length && (
      <div className="mt-3" data-testid={latest ? "inventory-unexpected-list" : undefined}>
        <p className="text-[11px] uppercase tracking-widest text-[#6E665D] mb-1.5">Not expected here</p>
        {check.unexpected.map((m) => (
          <p key={m.barcode} className="text-sm text-[#F5F0EB]"><span className="font-mono text-xs text-[#D4AF37] mr-3">{m.barcode}</span>{m.label}{m.recorded_at ? ` · recorded at ${m.recorded_at}` : ""}</p>
        ))}
        <p className="text-xs text-[#6E665D] mt-2">Use Scan → Change location to move them here.</p>
      </div>
    )}
  </div>
);

export const InventoryHistory = ({ checks }) => {
  if (!checks.length) return <p className="text-sm text-[#6E665D] mb-8" data-testid="inventory-none">No inventory recorded for this location yet.</p>;
  const [latest, ...rest] = checks;
  return (
    <div className="space-y-3 mb-10" data-testid="inventory-history">
      <Result check={latest} latest />
      {rest.map((c) => <Result key={c.id} check={c} />)}
    </div>
  );
};
